<div
  class="flex justify-start w-full m-auto"
  [style.gap]="columnWidth() / 400 + 'rem'"
  #masonryMain
>
  @defer (hydrate on viewport) {
    @if (loading() || actualColumnWidth() == -1) {
      @for (item of emptyArr(); track $index) {
        <p-skeleton [width]="columnWidth() + 'px'" [height]="(columnWidth() / 16) * 9 + 'px'" />
      }
    } @else {
      @for (col of columnItems(); track $index; let idx = $index) {
        <div class="flex flex-col min-w-0 w-fit" [style.gap]="actualColumnWidth() / 400 + 'rem'">
          @for (item of col; track item.image._id) {
            <div class="cursor-pointer" (click)="imageClicked.emit(item.image)">
              @if (useAuthImagePipe()) {
                <img
                  [class]="loadFullImages()? 'transition-[10s] blur-xs overflow-hidden' : ''"
                  [src]="getThumbLink(item.image._id) | useHttpImgSrc"
                  [width]="item.width"
                  [height]="item.height"
                  (load)="setThumbLoaded(idx, item.image._id)"
                  [style.opacity]="item.thumbLoaded ? '1' : '0'"
                  [style.display]="item.fullLoaded ? 'none' : 'block'"
                />
                @if (loadFullImages()) {
                  <img
                    [src]="getImageLink(item.image._id) | useHttpImgSrc"
                    [width]="item.width"
                    [height]="item.height"
                    (load)="setFullImageLoaded(idx, item.image._id)"
                    [style.opacity]="item.fullLoaded ? '1' : '0'"
                    [style.height]="item.fullLoaded ? undefined : '0'"
                  />
                }
              } @else {
                <img
                  [class]="loadFullImages()? 'transition-[10s] blur-xs overflow-hidden' : ''"
                  [src]="getThumbLink(item.image._id)"
                  [width]="item.width"
                  [height]="item.height"
                  (load)="setThumbLoaded(idx, item.image._id)"
                  [style.opacity]="item.thumbLoaded ? '1' : '0'"
                  [style.display]="item.fullLoaded ? 'none' : 'block'"
                />
                @if (loadFullImages()) {
                  <img
                    [src]="getImageLink(item.image._id)"
                    [width]="item.width"
                    [height]="item.height"
                    (load)="setFullImageLoaded(idx, item.image._id)"
                    [style.opacity]="item.fullLoaded ? '1' : '0'"
                    [style.height]="item.fullLoaded ? undefined : '0'"
                  />
                }
              }
            </div>
          }
        </div>
      }
    }
  }
</div>
